export const ru = {
    'title': 'Сбор звонка',
    'back-link-title': 'На главную',
    'templates-title': 'Применить шаблон',
    'mobile-templates-title-closed': 'Показать список шаблонов',
    'mobile-templates-title-opened': 'Скрыть список шаблонов',
    'create-call-screen-title': 'Собрать звонок',
    'without-name': 'Без названия',
};
